module.exports = __webpack_public_path__ + "img/coupon-2.e7707f7a.png";